module.exports = __webpack_public_path__ + "img/traction_wallet_transaction_receipt_logo.7e4929ab.svg";